import { createAction, createFeatureSelector, createReducer, createSelector, on, props } from "@ngrx/store"
import { State } from "."
import { PathValueModel } from "../form-json.types"

export const formStateFeatureKey = 'form'

export interface FormState {
  [key: string]: {
    [key: string]: any
  }
}

export const updateFormStateAction = createAction(
  '[Form Core Module] Update Form State',
  props<FormState>()
)

const initialFormState: FormState = {}

export const formStateReducer = createReducer(
  initialFormState,
  on(updateFormStateAction, (state, action) => {
    const obj = { ...state }
    for (let form in action) {
      if (form !== 'type') {
        const _obj = action[form]
        obj[form] = { ...obj[form], ..._obj }
      }
    }
    return obj
  })
)

export const selectForm = createFeatureSelector<State, FormState>(formStateFeatureKey)
export const selectPathValue = (path: PathValueModel) => {
  return createSelector(
    selectForm,
    (state: FormState) => state[path.relationships.form.data.id][path.attributes.path]
  )
}
export const selectPath = (path: string) => {
  return createSelector(
    selectForm,
    (state: FormState) => state[Object.keys(state)[0]][path]
  )
}